import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from '@angular/core';
import { PercPipe } from '../../../../../pipes/perc.pipe';
import { User } from '../../../../../models/User';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'domain-viewability',
  templateUrl: './domain-viewability.html',
  styleUrls: ['./domain-viewability.css'],
  inputs: ['data']
})
export class DomainViewability implements OnInit, OnChanges {
  @Input() domain;
  @Input() data;
  @Input() appName;
  @Input() isFollowing;
  @Output() anchorClick: EventEmitter<any> = new EventEmitter<any>();

  toggle = false;
  headers = [];
  adSizes = [];
  percPipe = new PercPipe();
  lineChartData: Array<ChartData> = [];

  get isFreemium(): boolean {
    return this.userService.isFreemium();
  }

  toggleShow() {
    this.toggle = !this.toggle;
  }

  constructor(private userService: User) {}

  ngOnInit() {}

  ngOnChanges() {
    this.adSizes = JSON.parse(
      JSON.stringify(this.data['viewabilityDistribution']['adSizes'])
    );
    this.headers = [];
    this.headers.push({
      class: 'col-4',
      text: 'TOP AD SIZE',
      key: 'adSize',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col',
      text: 'CONTRIBUTION',
      key: 'totalInventoryRatio',
      tooltipkey: ''
    });
    this.headers.push({
      class: 'col',
      text: 'EST. VIEWABILITY %',
      key: 'viewability',
      tooltipkey: ''
    });
    for (const adSize of this.adSizes) {
      // <!--<div class="col-md-3 col-lg-3">{{adData.adSize}}</div>-->
      // <!--<div class="col-md-3 col-lg-3 text-xs-right">{{adData.totalInventoryRatio | perc:'1.2-2'}}</div>-->
      if (this.isFreemium) {
        adSize['totalInventoryRatioHTML'] =
          '<div class="freemium-lock"><i class="fa fa-lock"></i></div>';
      } else {
        const totalInventoryRatio = adSize['totalInventoryRatio'];
        adSize['totalInventoryRatio'] = this.percPipe.transform(
          totalInventoryRatio,
          '1.2-2'
        );
      }

      // <!--<div class="col-md-3 col-lg-3 text-xs-right">{{adData.viewability | perc:'1.2-2'}}</div>-->
      const viewability = adSize['viewability'];
      adSize['viewability'] = this.percPipe.transform(viewability, '1.2-2');

      // <!--<div class="col-md-3 col-lg-3 text-xs-right">{{adData.nonGivtSivtViewability | perc:'1.2-2'}}</div>-->
      if (this.isFreemium && !this.isFollowing) {
        adSize['nonGivtSivtViewabilityHTML'] =
          '<div class="freemium-lock"><i class="fa fa-lock"></i></div>';
      } else {
        const nonGivtSivtViewability = adSize['nonGivtSivtViewability'];
        adSize['nonGivtSivtViewability'] = this.percPipe.transform(
          nonGivtSivtViewability,
          '1.2-2'
        );
      }
    }

    if (this.data?.viewabilityDistribution?.byMonth) {
      this.lineChartData = this.data?.viewabilityDistribution?.byMonth;
      this.lineChartData.reverse();
    }
  }
}
